import { configFetch as fetch } from '@laigu/utils';

export const agentInputtingApi = ({ trackId }) => {
  return new Promise(() => {
    fetch({
      url: '/agent/inputting',
      method: 'post',
      data: { track_id: trackId }
    });
  });
};

// 获取我的信息
export const getMyInfoApi = () => {
  return fetch({
    url: '/agent/info',
    method: 'get'
  }).then(res => {
    return (res && res.data) || {};
  });
};

export const updateAgentInfoApi = ({ agentId, data }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/agents/${agentId}`,
      method: 'put',
      data
    })
      .then(res => {
        resolve((res && res.data) || {});
      })
      .catch(e => {
        reject(e);
      });
  });
};
export const updateAgentAvatarApi = data => {
  const { agentId, header, ...rest } = data;
  return fetch({
    url: `/agent/agents/${agentId}`,
    method: 'PUT',
    headers: header,
    data: rest
  });
};

export const getCaptchasApi = () => {
  const time = new Date().getTime();
  return fetch({
    url: `/captchas?_=${time}`,
    method: 'POST'
  });
};

export const resetPasswordApi = ({ data, header }) => {
  return fetch({
    url: '/request_reset',
    method: 'POST',
    headers: header,
    data
  });
};
